import React from "react";
import LegalPage from "@/components/LegalPage";

const FALLBACKS = {
  terms: {
    eyebrow: "· LEGAL ·",
    title: "Terms of Use",
    effective_date: "Effective 1 January 2026",
    intro: "These Terms of Use govern your use of the Onedot6 website, operated by UNA.6. By using the website you agree to these Terms.",
    sections: [],
  },
  privacy: {
    eyebrow: "· LEGAL ·",
    title: "Privacy Policy",
    effective_date: "Effective 1 January 2026",
    intro: "This Privacy Policy explains how UNA.6 collects, uses and protects information you share through the Onedot6 website.",
    sections: [],
  },
  cookies: {
    eyebrow: "· LEGAL ·",
    title: "Cookie Policy",
    effective_date: "Effective 1 January 2026",
    intro: "This Cookie Policy explains how the Onedot6 website uses cookies and similar technologies.",
    sections: [],
  },
  service_terms: {
    eyebrow: "· LEGAL ·",
    title: "Service & Enquiry Terms",
    effective_date: "Effective 1 January 2026",
    intro: "These Service & Enquiry Terms explain how enquiries submitted through the Onedot6 website are handled.",
    sections: [],
  },
  intellectual_property: {
    eyebrow: "· LEGAL ·",
    title: "Intellectual Property & Content Policy",
    effective_date: "Effective 1 January 2026",
    intro: "This policy explains how Onedot6 content and third-party works are protected and may be used.",
    sections: [],
  },
};

export const Terms = () => <LegalPage pageKey="terms" fallback={FALLBACKS.terms} />;
export const Privacy = () => <LegalPage pageKey="privacy" fallback={FALLBACKS.privacy} />;
export const Cookies = () => <LegalPage pageKey="cookies" fallback={FALLBACKS.cookies} />;
export const ServiceTerms = () => <LegalPage pageKey="service_terms" fallback={FALLBACKS.service_terms} />;
export const IntellectualProperty = () => <LegalPage pageKey="intellectual_property" fallback={FALLBACKS.intellectual_property} />;
